export default function ResultCard({ game }) {
    return (
      <div className="bg-white rounded-xl shadow-md p-4 w-full max-w-sm space-y-2">
        <h3 className="text-lg font-bold mb-1">{game.name}</h3>
        {game.description && <p className="text-sm mb-2">{game.description}</p>}
  
        <ul className="text-sm text-gray-700 mb-2 space-y-1">
          {game.minPlayers && game.maxPlayers && (
            <li>プレイ人数：{game.minPlayers}〜{game.maxPlayers}人</li>
          )}
          {game.time && <li>所要時間：{game.time}</li>}
          {game.difficulty && <li>難易度：{game.difficulty}</li>}
          {game.age && <li>対象年齢：{game.age}</li>}
          {game.publisher && (
            <li>
              発売元：
              {game.publisherLink ? (
                <a
                  href={game.publisherLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 underline"
                >
                  {game.publisher}
                </a>
              ) : (
                game.publisher
              )}
            </li>
          )}
        </ul>
  
        {game.amazonLink && (
          <a
            href={game.amazonLink}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block px-3 py-1 text-sm bg-yellow-400 text-black rounded hover:bg-yellow-500"
          >
            Amazonで購入する
          </a>
        )}
      </div>
    );
  }
  